/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D4tInputs */

const en_mk_sol_ukm_d4t = /** @type {(inputs: Mk_Sol_Ukm_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16:00: anything going out passes a yes`)
};

const id_mk_sol_ukm_d4t = /** @type {(inputs: Mk_Sol_Ukm_D4tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`16.00: apa pun yang dikirim keluar lewat persetujuan`)
};

/**
* | output |
* | --- |
* | "16:00: anything going out passes a yes" |
*
* @param {Mk_Sol_Ukm_D4tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d4t = /** @type {((inputs?: Mk_Sol_Ukm_D4tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D4tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d4t(inputs)
	return en_mk_sol_ukm_d4t(inputs)
});